// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "DashboardExportFormatStatsItem" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { DocExportFormat } from "./doc-export-format.enum.gen";

export const DashboardExportFormatStatsItemGenShape = z.strictObject({
  name: z.string().optional(),
  format: z.enum(DocExportFormat),
  count: z.number(),
});
